/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';

/**
 * 
 * @export
 * @interface CompetitionVisibilityResponse
 */
export interface CompetitionVisibilityResponse {
    /**
     * 
     * @type {string}
     * @memberof CompetitionVisibilityResponse
     */
    id?: string;
    /**
     * 
     * @type {CompetitionType}
     * @memberof CompetitionVisibilityResponse
     */
    competitionType?: CompetitionType;
    /**
     * Whether this competition type is visible in the UI
     * @type {boolean}
     * @memberof CompetitionVisibilityResponse
     */
    isEnabled?: boolean;
    /**
     * Message shown when competition type is disabled
     * @type {string}
     * @memberof CompetitionVisibilityResponse
     */
    disabledMessage?: string;
    /**
     * Order in which to display this competition type
     * @type {number}
     * @memberof CompetitionVisibilityResponse
     */
    displayOrder?: number;
    /**
     * Human-readable label for this competition type
     * @type {string}
     * @memberof CompetitionVisibilityResponse
     */
    displayLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionVisibilityResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionVisibilityResponse
     */
    updatedAt?: number;
}



/**
 * Check if a given object implements the CompetitionVisibilityResponse interface.
 */
export function instanceOfCompetitionVisibilityResponse(value: object): value is CompetitionVisibilityResponse {
    return true;
}

export function CompetitionVisibilityResponseFromJSON(json: any): CompetitionVisibilityResponse {
    return CompetitionVisibilityResponseFromJSONTyped(json, false);
}

export function CompetitionVisibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionVisibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'competitionType': json['competitionType'] == null ? undefined : CompetitionTypeFromJSON(json['competitionType']),
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'disabledMessage': json['disabledMessage'] == null ? undefined : json['disabledMessage'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'displayLabel': json['displayLabel'] == null ? undefined : json['displayLabel'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function CompetitionVisibilityResponseToJSON(json: any): CompetitionVisibilityResponse {
    return CompetitionVisibilityResponseToJSONTyped(json, false);
}

export function CompetitionVisibilityResponseToJSONTyped(value?: CompetitionVisibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'competitionType': CompetitionTypeToJSON(value['competitionType']),
        'isEnabled': value['isEnabled'],
        'disabledMessage': value['disabledMessage'],
        'displayOrder': value['displayOrder'],
        'displayLabel': value['displayLabel'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

